export default "__VITE_ASSET__34ad94dc__"